// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import { createSlice } from '@reduxjs/toolkit';

// Caching of user preference (can be extended to theme/color...)

const initialState = {
  // Equipment canvas UI state
  equipmentGroupOpenState: {}, // { [nodeId]: boolean }
  equipmentGroupLayouts: {}, // { [nodeId]: 'vertical' | 'horizontal' | 'grid' }
  equipmentNodePositions: {}, // { [nodeId]: { x: number, y: number } }
  // Camera control layout user preference
  cameraControlMaximize: null, // camera group thumbnail size in camera control
  cameraControlsOpen: true,
  cameraMonitorOpen: false,
  cameraIsSwapped: false,

  // Preset list layout user preference
  presetViewMode: 'cards', // navigation mode in the camera control
  presetPreviewWidth: 150, // card size
  // per-item recall elevation: { [preset_uuid | preset_seq_uuid]: boolean }
  recallElevationByItemId: {},

  // Panel sidebar width
  panelWidth: 200,
};

const userPreferencesSlice = createSlice({
  name: 'userPreferences',
  initialState,
  reducers: {
    // Equipment canvas UI state
    setGroupOpen(state, { payload: { nodeId, isOpen } }) {
      state.equipmentGroupOpenState[nodeId] = isOpen;
    },
    setGroupLayout(state, { payload: { nodeId, layout } }) {
      state.equipmentGroupLayouts[nodeId] = layout;
    },
    setGroupsOpen(state, { payload }) {
      Object.assign(state.equipmentGroupOpenState, payload);
    },
    setNodePosition(state, { payload: { nodeId, position } }) {
      state.equipmentNodePositions[nodeId] = position;
    },
    setNodePositions(state, { payload }) {
      state.equipmentNodePositions = payload;
    },
    clearNodePosition(state, { payload: nodeId }) {
      delete state.equipmentNodePositions[nodeId];
    },
    setCameraControlMaximize: (state, action) => {
      state.cameraControlMaximize = action.payload;
    },
    setCameraControlsOpen: (state, action) => {
      state.cameraControlsOpen = action.payload;
    },
    setCameraMonitorOpen: (state, action) => {
      state.cameraMonitorOpen = action.payload;
    },
    setCameraIsSwapped: (state, action) => {
      state.cameraIsSwapped = action.payload;
    },
    setPresetViewMode: (state, action) => {
      state.presetViewMode = action.payload;
    },
    setPresetPreviewWidth: (state, action) => {
      state.presetPreviewWidth = action.payload;
    },
    setRecallElevationForItem: (state, action) => {
      const { itemId, value } = action.payload;
      state.recallElevationByItemId[itemId] = value;
    },
    setPanelWidth: (state, action) => {
      state.panelWidth = action.payload;
    },
  },
});

export const {
  setCameraControlMaximize,
  setCameraControlsOpen,
  setCameraMonitorOpen,
  setCameraIsSwapped,
  setPresetViewMode,
  setPresetPreviewWidth,
  setRecallElevationForItem,
  setPanelWidth,
  setGroupOpen,
  setGroupLayout,
  setGroupsOpen,
  setNodePosition,
  setNodePositions,
  clearNodePosition,
} = userPreferencesSlice.actions;

export default userPreferencesSlice.reducer;
